import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { StyleFunctionProps, defineStyle } from "@chakra-ui/styled-system";

import { combineObjects } from "@nens/shared-utils";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  alertAnatomy.keys
);

const DEFAULT_PROPS = {
  container: defineStyle({ borderWidth: "base", rounded: "base", gap: 4 }),
};

const ONLY_ICON_PROPS = {
  container: defineStyle({
    p: 0,
    w: "fit",
    rounded: "full",
    borderWidth: 0,
  }),
  icon: defineStyle({
    m: 0,
  }),
  spinner: defineStyle({
    m: 0,
  }),
};

const baseStyle = definePartsStyle((props: Partial<StyleFunctionProps>) => {
  const { status, variant } = props;

  const statusProps = (() => {
    if (status === "success")
      return {
        container: defineStyle({
          borderColor: "semantic.success.main",
          bg: "semantic.success.background",
        }),
        icon: defineStyle({
          color: "semantic.success.main",
        }),
      };

    if (status === "warning")
      return {
        container: defineStyle({
          borderColor: "semantic.warning.main",
          bg: "semantic.warning.background",
        }),
        icon: defineStyle({
          color: "semantic.warning.main",
        }),
      };

    if (status === "error")
      return {
        container: defineStyle({
          borderColor: "semantic.error.main",
          bg: "semantic.error.background",
        }),
        icon: defineStyle({
          color: "semantic.error.main",
        }),
      };

    if (status === "info")
      return {
        container: defineStyle({
          borderColor: "semantic.info.main",
          bg: "semantic.info.background",
        }),
        icon: defineStyle({
          color: "semantic.info.main",
        }),
      };

    return {
      container: defineStyle({
        borderColor: "brand.border",
        bg: "brand.cloudy",
      }),
    };
  })();

  return combineObjects(
    DEFAULT_PROPS,
    statusProps ?? {},
    variant === "icon-only" ? ONLY_ICON_PROPS : {}
  );
});

export const alertTheme = defineMultiStyleConfig({ baseStyle });
